import styles from './TranslationSwitch.module.scss';
import { ReactComponent as OriginalTextIcon } from '../../assets/originalText.svg';
import { ReactComponent as TranslationIcon } from '../../assets/translation.svg';
import { useTranslation } from 'react-i18next';

interface TranslationSwitchProps {
  isLoading: boolean;
  isBulkTranslation?: boolean;
  isTranslation: boolean;
  handleTranslation: (isTranslation: boolean) => void;
  theme?: 'light' | 'dark';
  size?: 'small' | 'medium' | 'large';
  isDisabled?: boolean;
}

export const TranslationSwitch: React.FC<TranslationSwitchProps> = ({
  isLoading = false,
  isTranslation,
  isBulkTranslation = false,
  handleTranslation,
  theme = 'light',
  size = 'medium',
  isDisabled = false,
}) => {
  const { t } = useTranslation();

  const themeClass = theme === 'dark' ? styles.dark : styles.light;
  const buttonSizeClass =
    size === 'small'
      ? styles.small
      : size === 'large'
      ? styles.large
      : styles.medium;

  const labelTextSize =
    size === 'small'
      ? styles.smallLabel
      : size === 'large'
      ? styles.largeLabel
      : styles.mediumLabel;

  return (
    <div
      className={`${styles.translationSwitch} ${
        isLoading ? styles.loading : ''
      } ${isDisabled ? styles.disabled : ''}`}
      onClick={(e) => {
        e.stopPropagation();
        if (isLoading) return;
        handleTranslation(!isTranslation);
      }}
    >
      <label className={`${styles.switchLabel} ${labelTextSize}`}>
        {!isBulkTranslation
          ? ''
          : isBulkTranslation && !isLoading
          ? t('Translate all') + ':'
          : t('Translating') + ':'}
      </label>
      <div
        className={`${
          styles.translationWrapper
        } ${themeClass} ${buttonSizeClass} ${isLoading ? styles.loading : ''} `}
      >
        <span className={styles.iconWrapper}>
          <span className={isTranslation ? '' : styles.active}>
            <OriginalTextIcon />
          </span>
          <span className={isTranslation ? styles.active : ''}>
            <TranslationIcon />
          </span>
        </span>
      </div>
    </div>
  );
};
